export const API_BASE_URL =
  process.env.NODE_ENV === 'production' || process.env.REACT_APP_DEV_REMOTE === 'remote'
    ? process.env.REACT_APP_BACKEND_SERVER + '/api/'
    : 'https://stms.dashenbanksc.com/api/';
export const BASE_URL =
  process.env.NODE_ENV === 'production' || process.env.REACT_APP_DEV_REMOTE === 'remote'
    ? process.env.REACT_APP_BACKEND_SERVER
    : 'https://stms.dashenbanksc.com/';
export const ACCESS_TOKEN_NAME = 'x-auth-token';